import Header from '../../components/Header'
import { useTheme } from '../../contexts/ThemeContext'
import 'primeicons/primeicons.css'

export default function AboutPage() {
  const { theme } = useTheme()

  return (
    <main className={`min-h-screen ${theme === 'dark' ? 'bg-black text-white' : 'bg-gray-100 text-gray-900'}`}>
      <Header />

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/about.jpg"
            alt="About background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative z-10 py-20 px-4 text-center">
          <div className="container mx-auto max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight text-white">
              Gặp Gỡ  <span className="text-gold-400">Coach Khang</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-200">
             Người đồng hành trên hành trình bóng đá của bạn
            </p>
          </div>
        </div>
      </section>

      {/* STORY + IMAGE */}
      <section className="py-14 px-4">
        <div className="container mx-auto grid md:grid-cols-2 gap-10 items-center max-w-6xl">

          {/* TEXT */}
          <div className="space-y-6">
            <h2 className={`text-2xl md:text-3xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
              Câu chuyện của tôi
            </h2>

            <p className={`leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
              Tôi là <strong className="text-gold-400">Coach Khang</strong> – người sáng lập Saigon FC, huấn luyện viên bóng đá dành cho người lớn, người đi làm và những ai từng nghĩ mình đã "qua tuổi đá bóng".
            </p>

            <p className={`leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
              Sau nhiều năm trực tiếp huấn luyện và tổ chức các lớp bóng đá phong trào tại <strong className="text-gold-400">Tân Phú – Tân Bình</strong>, tôi nhận ra một điều:
            </p>

            <p className={`leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
              👉 Không phải bạn đá dở, mà là bạn chưa được tập đúng cách.
            </p>

            <p className={`leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
              Tại đây, tôi chia sẻ:
            </p>

            <ul className={`list-disc list-inside space-y-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Các bài tập thực tế dễ áp dụng</li>
              <li>Lộ trình tập luyện rõ ràng cho người lớn bận rộn</li>
              <li>Kinh nghiệm giúp bạn chơi bóng thông minh hơn, bền hơn và ít chấn thương hơn</li>
            </ul>

            <p className={`leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
              Nếu bạn muốn đá bóng tốt lên từng tuần, hiểu rõ vị trí của mình trên sân và tận hưởng bóng đá một cách trọn vẹn hơn —<br />
              tôi ở đây để đồng hành cùng bạn.
            </p>

            <div className="pt-4">
              <button
                onClick={() => window.open('https://zalo.me/0976950338', '_blank')}
                className="px-6 py-3 bg-gold-gradient text-black font-bold rounded-lg shadow-lg shadow-gold-500/30 hover:shadow-xl hover:shadow-gold-500/50 transition-all duration-300 transform hover:scale-105 active:scale-95"
              >
                Kết nối với tôi trên Zalo
              </button>
            </div>
          </div>

          {/* IMAGE */}
          <div className="relative">
            <div className={`rounded-2xl overflow-hidden ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
              <div className="relative w-full h-[500px] md:h-[600px] group">
                <img
                  src="/images/coach-nhat-Dx1pr0EJ.jpg"
                  alt="Coach Khang"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Text Overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6">
                  <h3 className={`text-2xl font-bold mb-1 text-white`}>Coach Khang</h3>
                  <p className={`text-sm text-gray-300`}>Người sáng lập Saigon FC</p>
                </div>
              </div>
            </div>

            {/* BADGE */}
            <div className={`absolute -bottom-4 -right-4 bg-gold-gradient text-black px-5 py-2.5 rounded-full text-sm font-bold shadow-xl ${theme === 'dark' ? 'shadow-gold-500/50' : 'shadow-gold-400/50'} transform hover:scale-110 transition-transform`}>
              Since 2019
            </div>
          </div>
        </div>
      </section>

      {/* EXPERIENCE WITH IMAGES */}
      <section className={`py-20 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
        <div className="container mx-auto max-w-7xl">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-14">
            KINH NGHIỆM NỔI BẬT
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

            {/* ITEM 1 */}
            <div className="group">
              <div className="overflow-hidden rounded-2xl mb-4">
                <img
                  src="/images/about_1.jpg" // ảnh bạn thay sau
                  alt="Cựu cầu thủ CLB Long An"
                  className="w-full h-[260px] object-cover group-hover:scale-110 transition-transform duration-500"
                  style={{ objectPosition: 'center 25%' }}
                />
              </div>

              <h3 className="text-lg font-bold uppercase mb-1">
                Cựu cầu thủ CLB Long An
              </h3>
              <p className="text-gold-400 text-sm">
                Thi đấu tại V.League 2
              </p>
            </div>

            {/* ITEM 2 */}
            <div className="group">
              <div className="overflow-hidden rounded-2xl mb-4">
                <img
                  src="/images/about2.jpg"
                  alt="5+ năm huấn luyện"
                  className="w-full h-[260px] object-cover group-hover:scale-110 transition-transform duration-500"
                  style={{ objectPosition: 'center 65%' }}
                />
              </div>

              <h3 className="text-lg font-bold uppercase mb-1">
                5+ năm huấn luyện
              </h3>
              <p className="text-gold-400 text-sm">
                Kinh nghiệm thực chiến
              </p>
            </div>

            {/* ITEM 3 */}
            <div className="group">
              <div className="overflow-hidden rounded-2xl mb-4">
                <img
                  src="/images/about3.jpg"
                  alt="Hàng trăm học viên"
                  className="w-full h-[260px] object-cover group-hover:scale-110 transition-transform duration-500"
                  style={{ objectPosition: 'center 65%' }}
                />
              </div>

              <h3 className="text-lg font-bold uppercase mb-1">
                Hàng trăm học viên
              </h3>
              <p className="text-gold-400 text-sm">
                Từ cơ bản đến nâng cao
              </p>
            </div>

            {/* ITEM 4 */}
            <div className="group">
              <div className="overflow-hidden rounded-2xl mb-4">
                <img
                  src="/images/about_4.jpg"
                  alt="Đào tạo thực tế"
                  className="w-full h-[260px] object-cover group-hover:scale-110 transition-transform duration-500"
                  style={{ objectPosition: 'center 15%' }}
                />
              </div>

              <h3 className="text-lg font-bold uppercase mb-1">
                SAIGON FC
              </h3>
              <p className="text-gold-400 text-sm">
                Sáng lập và vận hành
              </p>
            </div>

          </div>
        </div>
      </section>


    </main>
  )
}


